import moment from 'moment-timezone';

const DEFAULT_TIMEZONE = 'America/Caracas'; // Default fallback

export const getHotelTimezone = () => {
  try {
    const hotel = JSON.parse(localStorage.getItem('hotelData'));
    return hotel?.timezone || DEFAULT_TIMEZONE;
  } catch (error) {
    return DEFAULT_TIMEZONE;
  }
};

// Returns a moment object in the hotel's timezone
export const getHotelMoment = (dateInput) => {
  const tz = getHotelTimezone();
  return dateInput ? moment(dateInput).tz(tz) : moment().tz(tz);
};

// Formats a date string for HTML inputs (datetime-local)
export const getHotelInputDateTime = (addMinutes = 0) => {
  return getHotelMoment().add(addMinutes, 'minutes').format('YYYY-MM-DDTHH:mm');
};

// Converts a form input string (YYYY-MM-DDTHH:mm) which represents Hotel Time, to a UTC ISO string
export const hotelInputToUTC = (inputString) => {
  const tz = getHotelTimezone();
  return moment.tz(inputString, tz).toISOString();
};

// Formats a date for display
export const formatHotelDate = (date, format = 'DD/MM/YYYY HH:mm') => {
  return getHotelMoment(date).format(format);
};

export const getTimezones = () => {
  return moment.tz.names();
};

// Helper for Report Filtering
export const reportDateHelpers = {
  // Check if a date string falls within "Today" in Hotel Time
  isToday: (dateString) => {
    const target = getHotelMoment(dateString);
    const now = getHotelMoment();
    return target.isSame(now, 'day');
  },

  // Get start/end timestamps for filtering
  getPeriodRange: (type) => {
    const now = getHotelMoment();
    let start, end;

    switch (type) {
      case 'today':
        start = now.clone().startOf('day');
        end = now.clone().endOf('day');
        break;
      case 'weekly':
        start = now.clone().startOf('week'); // Locale aware? usually Sunday/Monday. Moment default is Sunday.
        end = now.clone().endOf('week');
        break;
      case 'monthly':
        start = now.clone().startOf('month');
        end = now.clone().endOf('month');
        break;
      case 'yearly':
        start = now.clone().startOf('year');
        end = now.clone().endOf('year');
        break;
      default:
        start = now.clone().startOf('day');
        end = now.clone().endOf('day');
    }
    return { start, end };
  },

  // Get previous period range
  // Get previous period range
  getPreviousPeriodRange: (type) => {
    const now = getHotelMoment();
    let start, end;

    switch (type) {
      case 'today': {
        const yesterday = now.clone().subtract(1, 'day');
        start = yesterday.clone().startOf('day');
        end = yesterday.clone().endOf('day');
        break;
      }
      case 'weekly': {
        const lastWeek = now.clone().subtract(1, 'week');
        start = lastWeek.clone().startOf('week');
        end = lastWeek.clone().endOf('week');
        break;
      }
      case 'monthly': {
        const lastMonth = now.clone().subtract(1, 'month');
        start = lastMonth.clone().startOf('month');
        end = lastMonth.clone().endOf('month');
        break;
      }
      case 'yearly': {
        const lastYear = now.clone().subtract(1, 'year');
        start = lastYear.clone().startOf('year');
        end = lastYear.clone().endOf('year');
        break;
      }
      default:
        start = now.clone();
        end = now.clone();
    }
    return { start, end };
  },

  // Generic filter function
  isInRange: (dateString, startMoment, endMoment) => {
    const target = getHotelMoment(dateString);
    return target.isBetween(startMoment, endMoment, null, '[]'); // [] = inclusive
  }
};
